<script setup lang="ts">
import ContactUsCard from './ContactUsCard.vue';
import type { ContactUsSectionModel } from '../../api/interfaces/contactUsSectionModel';
import type { PhoneNumbers } from './composables/usePhoneInteraction';

interface ContactUsSliderProps {
  sections: ContactUsSectionModel[];
  helpCenterNumbers: PhoneNumbers;
}

const { sections } = defineProps<ContactUsSliderProps>();

const emit = defineEmits<{
  sectionClick: [section: ContactUsSectionModel];
}>();

// handle section click from child components
const handleSectionClick = (section: ContactUsSectionModel) => {
  emit('sectionClick', section);
};
</script>

<template>
  <div class="contact-us-large-sections">
    <div class="contact-us-cards-container">
      <div class="contact-us-cards-track">
        <ContactUsCard
          v-for="(section, index) in sections"
          :key="section.section"
          :section="section"
          :help-center-numbers="helpCenterNumbers"
          :is-first="index === 0"
          :on-section-click="handleSectionClick"
          @section-click="handleSectionClick"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  @import 'src/main/style/contactUs.scss';
</style>
